import { ActionTree } from "vuex";
import { CategoryState } from "@/store/category/type";
import { RootState } from "@/store/type";
import Api from "@/api/Api";
import { CategoryMutations } from "@/store/category/mutations";
import { Category } from "@/models/category";
import icons from "@/utils/icons";
import { i18n } from "vue-lang-router";

export const actions: ActionTree<CategoryState, RootState> = {
  getCategoryTree({ commit, state }): Promise<Category> | Category {
    return Api.category.getTree()
      .then((data: Category) => {
        if (data.children && data.children.length > 0) {

            const order = ['/Couettes', '/Oreillers' ,'/Linge de Lit', '/Literie', '/Linge de bain' ]

            data.children.sort(function (a, b)  {

                 a.index = order.indexOf(a.path)
                 b.index = order.indexOf(b.path)
                return a.index > b.index ? 1 : -1;

            })
          data.children.forEach((subcat) => {
            if (subcat.children) {
              subcat.children.sort(function (a, b) {
                return a.label.localeCompare(b.label);
              });
            }
          });
        }
        commit(CategoryMutations.SET_CATEGORY_TREE, data);
        return data;
      }).catch((e) => {
         // console.error(e);
        /*  if (e.status === 404) {
            Router.push("/404");
          }*/
        this.dispatch("sendNotification", {
          type: "danger",
          message: i18n.t("errors.server.access"),
          icon: icons.error,
        });
        return e;
      });

  },
};